import type { JSX } from "react";
import { useAuth } from "../features/auth/AuthProvider.js";
import { TaxonomyManager } from "../features/taxonomy/TaxonomyManager.js";

export function Taxonomy(): JSX.Element {
  const { me } = useAuth();
  const hhId = me?.user.currentHouseholdId ?? "";
  const myRole = me?.memberships.find((m) => m.householdId === hhId)?.role ?? "member";
  return (
    <>
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold">Taxonomy</h1>
        <p className="text-muted-foreground">
          Tags, categories, cuisines, and diet flags shared across your household. Used by
          the recipe library to power chip filters.
        </p>
      </header>
      <TaxonomyManager isOwner={myRole === "owner"} />
    </>
  );
}
